import React from "react"
import "../../css/ConnectView.css"
import ConnectPage from "../../components/ConnectComponent"
import ContentPage from "../../components/content-page"
import Meta from "../../components/meta"
import PropTypes from "prop-types"
 
 

let duration = 400

export class ConnectView extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			defaultStyle: {
				transition: `opacity ${duration}ms ease-in-out`,
				opacity: 0,
			},
		}
	}
	componentDidMount () {
		setTimeout(() => {
			this.setState({
				defaultStyle: {
					transition: `opacity ${duration}ms ease-in-out`,
					opacity: 1,
				}
			})
		}, 500)
	}
	render () {
		const { defaultStyle } = this.state
		const { location } = this.props
		return (
			<ContentPage>
				<Meta title="Winpe | Connect and join the Winpe Network" description="Subscribe to regular email communications and updates, including news about our conferences and access to exclusive invite-only events, via the Connect form." image={"https://winpeforum.com/assets/elements/ConnectNetwork.png"} location={location} />
				<Meta title="Winpe | Connect and join the Winpe Network" description="Subscribe to regular email communications and updates, including news about our conferences and access to exclusive invite-only events, via the Connect form." image={"https://winpeforum.com/assets/elements/ConnectNetwork.png"} location={location} />
				<div className="section__content" style={defaultStyle}>
					<div className="ConnectView_wrapper">
						<div className="ConnectView_section">
							<div className="ConnectView_content">
								<ConnectPage />
								
							</div>
						</div>
					</div>
				</div>
			</ContentPage>
		)
	}
}
ConnectView.propTypes = {
	location: PropTypes.object
}

export default ConnectView



// WEBPACK FOOTER //
// ./src/pages/connect/index.js